import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Container, Stars, btn } from './shared';
import { HeroVideo } from './HeroVideo';
import { ApplyDialog } from './ApplyDialog';
import { useSiteConfig } from '../../lib/siteConfig';

export const SlotsText = ({ c }) =>
  c.slots_free > 0
    ? `Start im ${c.next_start} · Noch ${c.slots_free} von ${c.slots_total} Plätzen frei`
    : `Start im ${c.next_start} · aktuell ausgebucht`;

const FACTS = ['Ex-Wirtschaftsprüfung', 'M.Sc. Business Administration', '8 Jahre aktiv an der Börse', '~30.000 Follower'];

export const Hero = () => {
  const c = useSiteConfig();
  const [applyOpen, setApplyOpen] = useState(false);
  return (
    <section className="relative overflow-hidden bg-paper pb-14 pt-12 sm:pb-20 sm:pt-20" data-testid="hero-section">
      <ApplyDialog open={applyOpen} onOpenChange={setApplyOpen} />
      <div className="pointer-events-none absolute left-1/2 top-24 h-[520px] w-[820px] -translate-x-1/2 rounded-full bg-brand/10 blur-[120px]" aria-hidden="true" />
      <Container className="relative max-w-[920px] text-center">
        <div className="hero-in">
          <span className="inline-flex items-center gap-2 rounded-full border border-line bg-white/[0.03] px-4 py-2 text-xs font-semibold text-brand sm:text-sm" data-testid="hero-badge">
            <span className={`h-2 w-2 rounded-full ${c.slots_free > 0 ? 'animate-pulse bg-brand' : 'bg-white/40'}`} aria-hidden="true" />
            <span data-testid="hero-slots-text"><SlotsText c={c} /></span>
          </span>
          <h1 className="mt-7 font-display text-4xl font-bold leading-[1.15] tracking-tight text-white sm:text-5xl lg:text-6xl" data-testid="hero-headline">
            Lerne in 4 Wochen, <span className="gold-text">Aktien selbst zu analysieren.</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-ink sm:text-lg" data-testid="hero-subline">
            1:1-Aktien-Mentoring für Berufstätige. Mit <span className="whitespace-nowrap">Live-Calls</span>, echten Aktienanalysen und persönlicher Begleitung.
          </p>
        </div>
        <div className="hero-in hero-in-delay mx-auto mt-10 max-w-[820px]">
          <HeroVideo />
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] text-ink/80 sm:text-xs" data-testid="hero-facts">
            {FACTS.map((f, i) => (
              <li key={f} className="flex items-center gap-3">
                {i > 0 && <span className="h-1 w-1 rounded-full bg-brand/60" aria-hidden="true" />}
                {f}
              </li>
            ))}
          </ul>
        </div>
        <div className="hero-in hero-in-delay mt-7 flex flex-col items-center gap-3">
          <a href={c.trustpilot_url} target="_blank" rel="noopener noreferrer" data-testid="hero-trustpilot-link"
             className="inline-flex flex-wrap items-center justify-center gap-2 rounded text-xs text-ink hover:text-white sm:text-sm">
            <Stars /> Alle Bewertungen 5 Sterne auf Trustpilot
          </a>
          <button type="button" onClick={() => setApplyOpen(true)} className={`${btn.primary} mt-2 w-full max-w-[420px] text-base sm:min-h-[56px]`} data-testid="hero-apply-btn">
            Kostenlos bewerben <ArrowRight size={18} aria-hidden="true" />
          </button>
          <a href={c.checklist_url} className={`${btn.outlineLight} w-full max-w-[420px]`} data-testid="hero-checklist-btn">
            Erst mal reinschnuppern: Gratis-Checkliste
          </a>
          <p className="text-xs text-ink">Kostenlos und unverbindlich</p>
        </div>
      </Container>
    </section>
  );
};
